module.exports = __webpack_public_path__ + "img/SS_Facility_Google-Map-Pin_Yellow.273a2962.png";